import React from "react";
import { ClipIcon, CloseIcon } from "assets/icons";
import styled from "styled-components";

interface AttachmentItemProps {
  url: string;
  fileName?: string;
  onClickRemove?: () => void;
  approvedDocument?: boolean;
}

const AttachmentItem = ({
  url,
  fileName,
  onClickRemove,
  approvedDocument,
}: AttachmentItemProps) => {
  const handleClickRemove: React.MouseEventHandler<SVGSVGElement> = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onClickRemove?.();
  };

  return (
    <AttachmentItemStyle
      href={url}
      target="_blank"
      approvedDocument={approvedDocument}
    >
      <IconAndFileNameStyle>
        <ClipIcon />
        <AttachmentFileNameStyle>{fileName}</AttachmentFileNameStyle>
      </IconAndFileNameStyle>
      {onClickRemove && <RemoveButton onClick={handleClickRemove} />}
    </AttachmentItemStyle>
  );
};

export default AttachmentItem;

/* 스타일 */
const AttachmentItemStyle = styled.a<{ approvedDocument?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: 4.6rem;
  padding: 1.2rem 1.4rem;

  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.color.background.white};
  border: 0.1rem solid
    ${({ theme, approvedDocument }) =>
      approvedDocument ? "none" : theme.color.stroke.light};

  cursor: pointer;

  svg {
    flex-shrink: 0;
    width: 2.4rem;
    height: 2.4rem;
    color: ${({ theme }) => theme.color.icon.tertiary};
  }

  &:hover {
    background-color: ${({ theme }) => theme.color.grey[100]};
    border: 0.1rem solid
      ${({ theme, approvedDocument }) =>
        approvedDocument ? "none" : theme.color.stroke.dark};
  }
`;

const IconAndFileNameStyle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  overflow: hidden;
`;

const AttachmentFileNameStyle = styled.p`
  flex: 1;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  ${({ theme }) => theme.typography.body1.regular}
  letter-spacing: -0.048rem;
`;

const RemoveButton = styled(CloseIcon)`
  z-index: 1;

  cursor: pointer;
`;
